import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { ThemeService } from './services/theme.service';
import { TranslationService } from './services/translation.service';
import { PlatformModeService } from './services/platform-mode.service';
import { FormFeedbackService } from './services/form-feedback.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  constructor(
    private themeService: ThemeService,
    private translationService: TranslationService,
    public readonly platformModeService: PlatformModeService,
    private readonly formFeedbackService: FormFeedbackService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnInit(): void {
    this.formFeedbackService.initialize();
    // Initialize theme and translation services
    // These services will load the user's preferences from localStorage
    if (this.platformModeService.isBrowserWeb()) {
      this.document.documentElement.classList.add('bw-browser-mode');
      this.document.body.classList.add('bw-browser-mode');
    }
  }
}
